import React, { useState, useContext } from "react";
import * as userApi from "../../../service/userApi";
import { HashLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import PageHeader from "../../pageheader/PageHeader";
import Breadcrumb from "../../public/breacrumb/breadcrumb";
import { CurrentUserContext } from "../../../App";
import ChangePasswordComponent from "../../material/changePassword";
import Footer from "../../footer/Footer";
import HeadBar from "../../public/headBar/HeadBar";

function ChangePassword() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [currentPass, setCurrentPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const nav = useNavigate();

  const onClickSubmit = async () => {
    if (!currentPass || !newPass || !confirmPassword) {
      setIsMessage({ type: "warning", data: "กรุณากรอกข้อมูลให้ครบถ้วน" });
    } else {
      setLoading(true);
      let res = await userApi.changPass(currentPass, newPass, confirmPassword);
      setLoading(false);
      if (res) {
        if (res?.data?.code === 200) {
          setIsMessage({ type: "success", data: "เปลี่ยนรหัสเรียบร้อย" });
          nav("/usermanagement");
        } else {
          setIsMessage({
            type: "warning",
            data: res?.data?.message_th || res?.data?.message,
          });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    }
  };
  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "เปลี่ยนรหัสผ่าน", url: "" },
  ];
  return (
    <>
      <div className="global-page">
        {/* <MenuAdmin /> */}

        <Breadcrumb pathItems={pathItems} />
        <HashLoader
          loading={loading}
          style={{ display: "flex", justifyContent: "center" }}
          color="#FF9768"
        />
        <PageHeader
          backpath={"/usermanagement"}
          titlename={"เปลี่ยนรหัสผ่าน"}
        />
        <ChangePasswordComponent
          currentPass={currentPass}
          setCurrentPass={setCurrentPass}
          newPass={newPass}
          setNewPass={setNewPass}
          confirmPassword={confirmPassword}
          setConfirmPassword={setConfirmPassword}
          onClickSubmit={onClickSubmit}
        />
      </div>
    </>
  );
}

export default ChangePassword;
